export default "__VITE_ASSET__21aada46__"